export class AuthProvider {
  id: string;
  time: Date;
  name: string = "";
  displayTitle: string = "";
  state: number = 0;
  type?: number = 0;
  protocolType?: number = 0;
  clientId: string = "";
  clientSecret: string = "";
  settings?: IAuthProviderSettings;
  iconUrl?: string;
  iconId?: string;
  fileImage: File = new File([], "default");
  isRequired: boolean;
  canBeRequired: boolean;
}

export class ShortAuthProvider {
  id: string;
  name: string = "";
  type?: number = 0;
  protocolType?: number = 0;
  iconUrl?: string;
  iconId?: string;
  displayTitle: string = "";
  isRequired: boolean;
  canBeRequired: boolean;
}

export interface IAuthProviderSettings {
  tokenUrl: string;
  authorizeUrl: string;
  scope: string;
  meUrl: string;
}
